import { Box, Typography } from '@mui/joy'
import { DataGrid } from '@mui/x-data-grid'
import { useMemo } from 'react'
import { GridCell } from '~/shared/ui/AsyncGrid'
import { columns } from './columns'
import { GridRow } from './types'

type HistoryChangesModalProps = {
  changeFields?: Omit<GridRow, 'id'>[]
}

export function ChangedFieldsList({
  changeFields = [],
}: HistoryChangesModalProps) {
  const rows = useMemo(
    () =>
      changeFields?.map((changeField, index) => ({
        ...changeField,
        id: String(index),
      })),
    [changeFields],
  )

  return (
    <>
      <Typography sx={{ marginBottom: '12px', fontWeight: 600 }}>
        Изменения
      </Typography>
      <Box
        sx={{
          width: '100%',
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          density='compact'
          disableColumnMenu
          disableColumnSelector
          hideFooter
          autoHeight
          components={{
            Cell: GridCell,
          }}
        />
      </Box>
    </>
  )
}
